import settings from './settings';
import { nanoid } from 'nanoid';
const temp = [
  '',
  'https://avatars.mds.yandex.net/get-pdb/1938902/53d74ac0-9362-49e7-b565-aa5e57b8cdf3/s1200?webp=false',
  ''
];
const batteryLvL = [3, 40, 70, 100];
const batteryType = ['DC', 'Half battery', 'Low battery', undefined];
export default {
  namespaced: true,
  modules: {
    settings
  },
  state: {
    data: []
  },
  getters: {
    columns(state) {
      return state.settings.data.map(i => {
        return {
          value: i,
          text: i
        };
      });
    }
  },

  actions: {
    load({ commit }, params) {
      if (!params) {
        const list = [];
        list.length = 40;
        list.fill({
          id: 1,
          name: 'Device',
          avatar: '',
          favorit: false,
          muted: false,
          status: 'Active',
          batteryType: 'DC',
          batteryLvL: 100,
          emulation: 'on',
          schemaName: 'Driver',
          rawEntity: [
            {
              id: nanoid(),
              subheader: 'Object group',
              type: 'tags',
              properties: [
                {
                  id: nanoid(),
                  title: 'Obj #1',
                  link: '/objects/1'
                },
                {
                  id: nanoid(),
                  title: 'Obj #2',
                  link: '/objects/2'
                },
                {
                  id: nanoid(),
                  title: 'Obj #3',
                  link: '/objects/3'
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Measurements',
              properties: [
                {
                  id: nanoid(),
                  title: 'Property name',
                  subtitle: 'Value'
                },
                {
                  id: nanoid(),
                  title: 'Property name',
                  subtitle: 'Value'
                },
                {
                  id: nanoid(),
                  title: 'Property name',
                  subtitle: 'Value'
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Settings',
              properties: [
                {
                  id: nanoid(),
                  title: 'Settings name',
                  subtitle: 'Value',
                  icon: 'mdi-autorenew'
                },
                {
                  id: nanoid(),
                  title: 'Settings name',
                  subtitle: 'Value'
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Commands',
              properties: [
                {
                  id: nanoid(),
                  title: 'Command name',
                  subtitle: 'Value',
                  icon: 'mdi-autorenew'
                },
                {
                  id: nanoid(),
                  title: 'Command name',
                  subtitle: 'Value'
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Credentials',
              properties: [
                {
                  id: nanoid(),
                  title: 'Credentials name',
                  subtitle: 'Value',
                  icon: 'mdi-autorenew'
                },
                {
                  id: nanoid(),
                  title: 'Credentials name',
                  subtitle: 'Value'
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Driver',
              properties: [
                {
                  id: nanoid(),
                  title: 'Driver name',
                  isNeedGap: false
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Description',
              properties: [
                {
                  id: nanoid(),
                  title: 'Device description',
                  isNeedGap: false
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'UUID',
              properties: [
                {
                  id: nanoid(),
                  title: 'UUID',
                  isNeedGap: false
                }
              ]
            }
          ]
        });
        commit(
          'set',
          list.map((i, n) => {
            return {
              ...i,
              id: i.id + n,
              name: `${i.name} ${n}`,
              avatar: temp[n] ? temp[n] : 'mdi-memory',
              batteryType: batteryType[n],
              batteryLvL: batteryLvL[n],
              schemaName: `${i.schemaName} ${n}`
            };
          })
        );
        commit(
          'settings/set',
          Object.keys(list[0]).filter(i => i !== 'avatar' && i !== 'rawEntity')
        );
      }
    }
  }
};
